























import { Component, Vue, Prop } from 'vue-property-decorator'
import { EmbeddedResouceTypes } from '@/components/comments/Schedule.vue'
import dayjs from 'dayjs'
import { ImageFile } from '@/types/image'
import { Patient } from '@/types/user'

@Component({
  components: {
    SyncImage: () => import('@/components/imageTab/SyncImage.vue'),
    ImageModal: () => import('@/components/imageTab/ImageModal.vue')
  }
})
export default class Schedule extends Vue {
  @Prop({ type: Object, required: true }) readonly patient!: Patient
  @Prop({ type: Number, required: true }) readonly id!: number
  @Prop({ type: String, required: true }) readonly type!: string

  imageFile: ImageFile | null = null
  imageFileUrl = ''

  get patientName() {
    return this.patient
      ? `${this.patient.lastName}${this.patient.firstName}`
      : ''
  }

  get senderName() {
    const image = this.imageFile

    if (!image) {
      return ''
    }

    return image.worker
      ? `${image.worker.lastName}${image.worker.occupation.name}`
      : this.patientName
  }

  get registeredDatetime() {
    return this.imageFile
      ? dayjs(this.imageFile.registeredDatetime).format('M月D日 HH:mm')
      : ''
  }

  get description() {
    return this.imageFile ? this.imageFile.description : ''
  }

  async fetchEmbeddedFile(type: string, patientId: number, id: number) {
    switch (type) {
      case EmbeddedResouceTypes.DICOM:
        return this.$api.dicom.fetchOne({ patientId, dicomId: id })

      case EmbeddedResouceTypes.IMAGE:
        return this.$api.image.fetchOne({ patientId, imageId: id })

      default:
        throw new Error(`type: ${type} not supported`)
    }
  }

  async fetchImageSource(type: string, patientId: number, id: number) {
    switch (type) {
      case EmbeddedResouceTypes.DICOM:
        return this.$api.dicom.fetchImage({
          patientId: this.patient.id,
          dicomId: id
        })

      case EmbeddedResouceTypes.IMAGE:
        return this.$api.image.fetchImage({
          patientId: this.patient.id,
          imageId: id
        })

      default:
        throw new Error(`type: ${type} not supported`)
    }
  }

  async handleImageCreated() {
    const res = await this.fetchImageSource(this.type, this.patient.id, this.id)
    const url = window.URL.createObjectURL(res)
    this.imageFileUrl = url
  }

  handleCloseModal() {
    this.$emit('close')
  }

  async created() {
    this.imageFile = await this.fetchEmbeddedFile(
      this.type,
      this.patient.id,
      this.id
    )
  }

  beforeDestroy() {
    URL.revokeObjectURL(this.imageFileUrl)
  }
}
